import { render } from "./TableIncidence_categories.vue?vue&type=template&id=0fada053&scoped=true"
import script from "./TableIncidence_categories.vue?vue&type=script&lang=js"
export * from "./TableIncidence_categories.vue?vue&type=script&lang=js"

import "./TableIncidence_categories.vue?vue&type=style&index=0&id=0fada053&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fada053"]])

export default __exports__